import _get from 'lodash/get';
import { applyProperties } from '../util/helpers';

/**
 *
 * @module PluginConfig
 * @desc
 * @class PluginConfig
 *
 */
class PluginConfig {

    /**
     *
     * @constructor
     * @param {Object} config
     *
     */
    constructor(config) {

        /**
         *
         * @type {Object}
         *
         */
        this.config = config;

        // Apply all the config properties to this object
        applyProperties(this, this.config);

        // Now, let's set some defaults

        /**
         *
         * @type {string}
         *
         */
        this.name = _get(config, 'name');

        /**
         *
         * @type {string}
         * @todo set to PluginType enum
         *
         */
        this.type = _get(config, 'type');

        /**
         *
         * @type {*}
         *
         */
        this.pluginReference = _get(config, 'pluginReference');

        if (!this.pluginReference) {

            throw new Error('PluginConfig.pluginReference is required!');

        }

    }

}

export default PluginConfig;
